import { render } from "./iframe.vue?vue&type=template&id=16ae6e5a&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"

import "./iframe.vue?vue&type=style&index=0&id=16ae6e5a&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ae6e5a"]])

export default __exports__